var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeletev2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 508 508",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.5,408.2l-18.9-250.5c-0.6-7.8-7.4-13.6-15.1-13c-7.8,0.6-13.6,7.4-13,15.1l18.9,250.5c0.6,7.4,6.3,13.7,15.1,13 C199.3,422.7,205.1,415.9,204.5,408.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M337.5,144.7c-7.8-0.6-14.5,5.2-15.1,13l-18.9,250.5c-0.6,7.7,5.2,14.5,13,15.1c8.9,0.7,14.6-5.6,15.1-13l18.9-250.5 C351.1,152,345.3,145.3,337.5,144.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M455.1,60h-136V35.3c0-19.5-15.8-35.3-35.3-35.3h-59.6c-19.5,0-35.3,15.8-35.3,35.3V60h-136c-7.8,0-14.1,6.3-14.1,14.1 s6.3,14.1,14.1,14.1h14.2l27.8,367.6c2.2,29.3,26.9,52.2,56.3,52.2h205.6c29.4,0,54.1-22.9,56.3-52.2l27.8-367.6h14.2    c7.8,0,14.1-6.3,14.1-14.1S462.9,60,455.1,60z M224.2,28.2h59.6c3.9,0,7.1,3.2,7.1,7.1V60h-73.7V35.3h-0.1    C217.1,31.4,220.3,28.2,224.2,28.2z M384.9,453.7c-1.1,14.6-13.5,26.1-28.1,26.1H151.2c-14.7,0-27-11.5-28.1-26.1L95.4,88.2h317.1 L384.9,453.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletev2);
export default __webpack_public_path__ + "static/media/Delete.v2.b8ec6cebb7a7d48fbcf9e783b0b6deb1.svg";
export { ForwardRef as ReactComponent };